/*!

=========================================================
* Black Dashboard React v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import React, {
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
  useCallback,
} from "react";
import { Link, useLocation } from "react-router-dom";
import MetaTags from "react-meta-tags";
// reactstrap components
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardImg,
  CardLink,
  CardSubtitle,
  CardText,
  CardTitle,
  Col,
  Container,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Form,
  FormGroup,
  Input,
  Label,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalBody,
  ModalFooter,
  Nav,
  NavItem,
  NavLink,
  Row,
  Spinner,
  UncontrolledDropdown,
  UncontrolledTooltip,
} from "reactstrap";

import { connect } from "react-redux";
// import CommentsBlock from "simple-react-comments";
import { arrayOf } from "prop-types";
import { Fragment } from "react";
import { Helmet } from "react-helmet";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import logo from '../assets/img/ziro.png'
import * as Utils from "./Utils";

function ListView(props) {
  const [userID, setUserID] = useState(props.userID);
  const [modal, setModal] = React.useState(false);
  const [title, setTitle] = React.useState("");
  const [description, setDescription] = React.useState("");
  const [programs, setPrograms] = React.useState([]);
  const [programIDs, setProgramIDs] = React.useState([]);
  const [list, setList] = React.useState({});
  const [listID, setListID] = React.useState("");
  const [isUser, setIsUser] = React.useState(false);
  const [flag, setFlag] = React.useState(false);
  const notificationAlertRef = React.useRef(null);

  const [profilePic, setProfilePic] = React.useState(logo);
  const [firstName, setFirstName] = React.useState("");
  const [lastName, setLastName] = React.useState("");
  //hook for spinner animations
  const [loading, setLoading] = React.useState(true);
  // random array for gradient thumbnail
  const [random , setRandom] = React.useState([]);

  function toggleModal() {
    setModal(!modal);
  }

  useEffect(() => {
    fetchListID();
  }, [props.userID]);

  function fetchListID() {
    let id = new URLSearchParams(props.location.search).get("id");
    setListID(id); //second render
    setFlag(flag => !flag); //use a toggable flag to determine props.userID update as listID is static once set
  }

  //once we succesfully get list id, fetch list info
  useEffect(() => {
    fetchList();
  }, [flag]);
 
  function fetchList() {
    if(listID){
      var xhr = new XMLHttpRequest();
      xhr.open(
        "GET",
        "https://zirostudio.appspot.com/fetchplaylist?playlist_id=" + listID
      );
  
      xhr.onload = function () {
        if ("status" in JSON.parse(xhr.responseText)) {
          return;
        }
        console.log(xhr.responseText)
        setList(JSON.parse(xhr.responseText)); //is type object
      };
      xhr.send();
    }
  }

  //extract project info from list object 
  useEffect(() => {
    getProjectIDs();
  }, [list])

  function getProjectIDs() {
    console.log(Object)
    if(Object.keys(list).length !== 0){
      setTitle(list.title);
      setDescription(list.description);
      setUserID(list.user_id);
  
      if (list.project_list.length > 0) {
        setProgramIDs(list.project_list.split(","));
      }
  
      if (list.proj_details.length > 0) {
        setPrograms(list.proj_details);
      } else if (list.proj_details.length === 0) {
        setRandom([(Math.floor(Math.random() * 5) + 1)]);
      }
    }
  }

  useEffect(() => {
    if(title !== ""){
      setLoading(false);
    }
  })

  useEffect(() => {
    if (userID) {
      Utils.getProfile(userID, profileCallback);
    }
  }, [userID]);

  function profileCallback(res){
    if(res){
      setFirstName(res.first_name);
      setLastName(res.last_name);
      setProfilePic(res.img_url.img_url);
    }
  }

  useEffect(() => {
    if(userID && props.userID){
      if(userID === props.userID){
        setIsUser(true);
      } else {
        setIsUser(false);
      }
    }
  }, [userID, props.userID])

  function deleteProjectFromPlaylist(listID, projectID) {
    var id_token = Utils.getCookie("ziroatoken");
    var xhr = new XMLHttpRequest();
    xhr.open(
      "POST",
      "https://zirostudio.appspot.com/editplaylist?authtoken=" + id_token
    );
    xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

    xhr.onload = function () {
      fetchList();
    };

    xhr.send(
      JSON.stringify({
        playlist_id: listID,
        file_id: projectID,
        operation: false,
      })
    );
  }

  function editList(title, description) {
    let sanitizedTitle = sanitizeString(title);
    let sanitizedDesc = sanitizeString(description);
    if(!sanitizedTitle || !sanitizedDesc ){
      return;
    }
    var id_token = Utils.getCookie("ziroatoken");
    var xhr = new XMLHttpRequest();
    xhr.open(
      "POST",
      "https://zirostudio.appspot.com/editplaylistmeta?authtoken=" + id_token
    );
    xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

    xhr.onload = function () {
      toggleModal();
      fetchList();
    };

    xhr.send(
      JSON.stringify({
        playlist_id: listID,
        title: sanitizedTitle,
        description: sanitizedDesc,
      })
    );
  }

  function sanitizeString(str){
    if(!str){
      return;
    }
    str = str.replace(/[^a-z0-9áéíóúñü \.,_-]/gim,"");
    return str.trim();
  }

  // updates programs array after user changes order
  function onDragEnd(result){
    if (!result.destination) {
      return;
    }
    const newPrograms = [...programs];
    const [removed] = newPrograms.splice(result.source.index, 1);
    newPrograms.splice(result.destination.index, 0, removed);
    setPrograms(newPrograms);
    updateOrder(newPrograms);
  }

  function updateOrder(programs){
    var id_token = Utils.getCookie("ziroatoken");
    var xhr = new XMLHttpRequest();
    xhr.open(
      "POST",
      "https://zirostudio.appspot.com/update-order?authtoken=" + id_token
    );
    xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
    xhr.onload = function () {
      fetchList();
    };
    xhr.send(
      JSON.stringify({
        list_id: listID,
        project_ids: programs
      })
    );
  }

  // if user exits from edit list modal, reset default values
  const resetListVal = () => {
    toggleModal();
    setTitle(list["title"]);
    setDescription(list["description"]);
  }

  return (
    <div className="content">
      <Row>
        <Col lg={12}>
          <Card className="card-tasks" style={{ height: "100%" }}>
            <CardBody>
              <Row>
                <Col xl={4}>
                  <Card>
                    <>                      
                      {programs.length > 0 && typeof(programs) !== undefined ? (
                        <img
                            className="img-fluid"
                            onError={Utils.addDefaultSrc}
                            src={
                              "https://storage.googleapis.com/user-thumbnails/" +
                              programs[0].file_id +
                              ".jpg"
                            }
                          ></img>
                      ) : (
                        <>
                          <img
                            className="img-fluid"
                            src={
                              "https://storage.googleapis.com/user-thumbnails/ziro-studio-default" +
                              (random[0]) +
                              ".jpg"
                            }
                          ></img>
                        </>
                      )}

                      <CardBody>
                        {programs.length === 0 && loading  ? (
                          <Row>
                            <Col>
                              <Spinner
                                animation="border"
                                color="info"
                                style={{
                                  padding: 0,
                                  margin: 7,
                                  marginLeft: 15,
                                }}
                              />
                            </Col>
                          </Row>
                          )
                        : null} 
                        
                        <CardText>
                          <Row>
                            <Col xs={10}>
                              <CardTitle>
                                <h2 style={{display: 'inline-block', wordWrap: 'break-word'}}>
                                  {list["title"]}
                                </h2>
                              </CardTitle>
                            </Col>
                            
                            <Col xs={2}>
                              {isUser ? (
                                <NavLink>
                                  <UncontrolledTooltip
                                    placement="top"
                                    target="edit"
                                    style={{ pointerEvents: "none" }}
                                  >
                                    Edit List Details
                                  </UncontrolledTooltip>
                                  <Button
                                    className="btn-round btn-icon animation-on-hover "
                                    color="success"
                                    style={{
                                      cursor: "pointer",
                                      float: "right",
                                      display: 'inline-block',
                                      marginTop: -10
                                    }}
                                    onClick={toggleModal}
                                    id="edit"
                                  >
                                    <i
                                      className="tim-icons icon-pencil"
                                      style={{ color: "white" }}
                                    />
                                  </Button>
                                </NavLink>
                              ) : (
                                <br></br>
                              )}
                            </Col>
                          </Row>
                          <Modal
                            isOpen={modal}
                            toggle={toggleModal}
                            style={{ paddingBottom: 10 }}
                            backdropClassName={"modal-dark"}
                          >
                            <div className="modal-header">
                              <h3
                                className="modal-title"
                                id="exampleModalLabel"
                              >
                                Edit List
                              </h3>
                              <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-hidden="true"
                                onClick={resetListVal}
                              >
                                <i className="tim-icons icon-simple-remove" />
                              </button>
                            </div>

                            <ModalBody>
                              <FormGroup
                                className={
                                  title.length <= 50 ? "" : "has-danger",
                                  title.length === 0 ? "has-danger" : null
                                }
                              >
                                <Label for="listName">
                                  <h4
                                    style={{ color: "black", marginBottom: 0 }}
                                  >
                                    List Name
                                  </h4>
                                </Label>
                                <Input
                                  type="text"
                                  id="projName"
                                  defaultValue={list["title"]}
                                  onChange={(txt) => setTitle(txt.target.value)}
                                  // onBlur={(txt) => {
                                  //   if (txt.target.value.trim().length <= 50 && txt.target.value.trim().length > 0) {
                                  //     list["title"] = txt.target.value;
                                  //   }
                                  // }}
                                ></Input>
                                <p
                                  style={{
                                    fontSize: "smaller",
                                    alignContent: "right",
                                    color: title.length > 50 || title.length === 0 ? "red" : ""
                                  }}
                                  className="float-right"
                                >
                                  {title.length + "/50"}
                                </p>
                              </FormGroup>
                              <FormGroup
                                className={
                                  description.length <= 250 ? "" : "has-danger",
                                  description.length === 0 ? "has-danger" : null
                                }
                              >
                                <Label for="listDesc">
                                  <h4
                                    style={{ color: "black", marginBottom: 0 }}
                                  >
                                    List Description
                                  </h4>
                                </Label>
                                <Input
                                  type="text"
                                  id="projDescription"
                                  defaultValue={list["description"]}
                                  onChange={(txt) =>
                                    setDescription(txt.target.value)
                                  }
                                  // onBlur={(txt) => {
                                  //   if (txt.target.value.trim().length <= 250 && txt.target.value.trim().length > 0) {
                                  //     list["description"] = txt.target.value;
                                  //   }
                                  // }}
                                />
                                <p
                                  style={{
                                    fontSize: "smaller",
                                    alignContent: "right",
                                    color:
                                      description.length > 250 || description.length === 0 ? "red" : "",
                                  }}
                                  className="float-right"
                                >
                                  {description.length + "/250"}
                                </p>
                              </FormGroup>
                            </ModalBody>
                          <ModalFooter>
                            {description.length > 250 || description.trim().length === 0 || title.length > 50 || title.trim().length === 0 ? (
                              <Button
                              className="animation-on-hover"
                              color="success"
                              style={{ marginLeft: 24, marginBottom: 16 }}
                              disabled
                            >
                              Save Changes
                            </Button>
                            ) : (
                              <Button
                                className="animation-on-hover"
                                color="success"
                                style={{ marginLeft: 24, marginBottom: 16 }}
                                onClick={() =>
                                  editList(title, description)
                                }
                              >
                                Save Changes
                              </Button>
                            )}
                          </ModalFooter>
                          </Modal>
                          {/* <UncontrolledDropdown>
                            <DropdownToggle caret data-toggle="dropdown">
                                Private
                            </DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem>Private</DropdownItem>
                                <DropdownItem>Unlisted</DropdownItem>
                                <DropdownItem>Public</DropdownItem>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                          <br></br> */}
                          <Row>
                            <Col xs={10}>
                              <CardText>
                                <h4 style={{marginTop: -30, marginLeft: 2}}>
                                  {list["description"]}
                                </h4>
                              </CardText>
                            </Col>
                          </Row>
                          <Link to={"/user-view?uid=" + list["user_id"]}>
                            <Row style={{ marginTop: 7 }}>
                              <div
                                className="author"
                                style={{ marginLeft: 18 }}
                              >
                                <a
                                  href=""
                                  onClick={(e) => e.preventDefault()}
                                >
                                  <img
                                    alt="..."
                                    className="avatar"
                                    src={profilePic}
                                  />
                                </a>
                              </div>
                              <a
                                className="description"
                                style={{
                                  marginLeft: 10,
                                  marginTop: 3,
                                  fontSize: "1rem",
                                }}
                              >
                                {firstName} {lastName}
                              </a>
                            </Row>
                          </Link>
                        </CardText>
                      </CardBody>
                    </>
                  </Card>
                </Col>
                <Col xl={8}>
                  <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId="list" isDropDisabled={!isUser}>
                      {provided => (
                        <div 
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                        >
                        {programs.length === 0 && loading  ? (
                          <Row>
                            <Col>
                              <Spinner
                                animation="border"
                                color="info"
                                style={{
                                  padding: 0,
                                  margin: 7,
                                  marginLeft: 15,
                                }}
                              />
                            </Col>
                          </Row>
                          )
                          : null}
                          {programs.length === 0 && !loading ? (
                            <Row>
                              <Col>
                                <h3>This user does not have any projects in their list.</h3>
                              </Col>
                            </Row>
                          )
                          : null}                 
                          {programs.map((item, index) => {
                            return(
                              <Draggable key={item.file_id} draggableId={item.file_id.toString()} index={index} isDragDisabled={!isUser}>
                                {provided => (
                                  <div 
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                  >
                                    <Col lg={11} style={{marginBottom: -25, marginLeft: 20, position: 'relative'}}>
                                      {isUser ? (
                                        <div style={{position: 'absolute', top: '44%', left: -5}}>
                                          <i style={{ float: 'right'}} className="fas fa-grip-lines gripBars" />
                                        </div>
                                      ) : null}
                                      <CardBody>
                                        <CardText />
                                        <Card>
                                          <Row noGutters={true}>
                                            <Col lg={5}>
                                              <Link to={{ pathname: "/studio?code=" + item['file_id']}} target="_blank">
                                                <img 
                                                  className="img-fluid"
                                                  onError={Utils.addDefaultSrc}
                                                  src={
                                                    "https://storage.googleapis.com/user-thumbnails/" +
                                                    item["file_id"] +
                                                    ".jpg"
                                                  }
                                                ></img>
                                              </Link>
                                              <Row style={{ marginTop: -45 }}>
                                                <Col>
                                                  <Link
                                                    to={{
                                                      pathname:
                                                        "/studio?code=" + item["file_id"],
                                                    }}
                                                    target="_blank"
                                                  >
                                                    <Button
                                                      className="btn-round btn-icon btn-clear"
                                                      style={{
                                                        backgroundColor:
                                                          "rgba(0, 0, 0, 0.3)",
                                                        backgroundImage: "",
                                                      }}
                                                      id={"toStudio" + item["file_id"]}
                                                    >
                                                      <i className="tim-icons icon-double-right" />
                                                    </Button>
                                                    <UncontrolledTooltip
                                                      placement="top"
                                                      target={"toStudio" + item["file_id"]}
                                                      style={{ pointerEvents: "none" }}
                                                    >
                                                      Proceed to Studio
                                                    </UncontrolledTooltip>
                                                  </Link>

                                                  <Link
                                                    to={
                                                        "/project-info?id=" +
                                                        item["file_id"]
                                                    }
                                                  >
                                                    <Button
                                                      className="btn-round btn-icon btn-clear"
                                                      style={{
                                                        backgroundColor:
                                                          "rgba(0, 0, 0, 0.3)",
                                                        backgroundImage: "",
                                                      }}
                                                      id={"moreInfo" + item["file_id"]}
                                                    >
                                                      <i className="fa fa-info" />
                                                    </Button>
                                                    <UncontrolledTooltip
                                                      placement="top"
                                                      target={"moreInfo" + item["file_id"]}
                                                      style={{ pointerEvents: "none" }}
                                                    >
                                                      More Information
                                                    </UncontrolledTooltip>
                                                  </Link>
                                                  {isUser ? (
                                                  <Button
                                                    className="btn-round btn-icon btn-clear animation-on-hover"
                                                    style={{
                                                      backgroundColor: "rgba(0, 0, 0, 0.3)",
                                                      backgroundImage: "",
                                                    }}
                                                    onClick={() => {
                                                      deleteProjectFromPlaylist(
                                                        listID,
                                                        item["file_id"]
                                                      );
                                                    }}
                                                  >
                                                    <i className="fa fa-times" />
                                                  </Button>
                                                  ) : null}
                                                  {/* Block flag for project cards */}
                                                   
                                                  <div
                                                  
                                                    style = {{
                                                      display: item["blockly"] ? "inline-block" : "none",
                                                    }}
                                                    
                                                    >
                                                      <Button
                                                      className="btn-round btn-icon btn-clear"
                                                      style={{
                                                        backgroundColor: "rgba(0, 0, 0, 0.3)",
                                                        backgroundImage: "",
                                                        
                                                      }}
                                                      id = {"BC" + item["fileID"]}
                                                    >
                                                    <p> <i
                                                        class="fa-solid fa-b"
                                                        
                                                      /> {item["blockly"] ? "B" : ""}
                                                    </p></Button>
                                                      
                                                  </div>
                                                </Col>
                                              </Row>
                                            </Col>
                                            
                                            <Col lg={7}>
                                              <CardBody>
                                              <CardText />
                                                <div className="author" style={{marginTop: -10}}>
                                                  <Link to={{ pathname: "/studio?code=" + item['file_id']}} target="_blank" >
                                                    <h3 style={{marginBottom: 5, fontSize: '1.5rem'}}>{item['title']}</h3>
                                                  </Link>
                                                  <p
                                                    className="description"
                                                    style={Utils.descStyle}
                                                  >
                                                    {item["description"]}
                                                  </p>
                                                </div>

                                                <Link
                                                  to={"/user-view?uid=" + item["user_id"]}
                                                >
                                                  <Row style={{ marginTop: 10 }}>
                                                    <Col>
                                                      <a
                                                        className="description"
                                                        style={{ marginTop: 5, fontSize: '1rem' }}
                                                      >
                                                        {item["user_name"]}
                                                  
                                                      </a>
                                                    </Col>
                                                  </Row>
                                                </Link>
                                              </CardBody>
                                            </Col>
                                          </Row>
                                        </Card>
                                      </CardBody>
                                    </Col>
                                    {provided.placeholder}
                                  </div>
                                )}
                              </Draggable>
                            )
                          })}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  userID: state.userID,
});

export default connect(mapStateToProps)(ListView);
